import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetPredefinedFlashMessageRequest extends APIRequest
{
   
}

export class GetPredefinedFlashMessageRequestImpl extends APIRequestDtoImpl implements GetPredefinedFlashMessageRequest
{
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesrequest.tsx